import styles from './footer.module.css';
import Sponsors from './studlar/sponsors';
import Contact from './contact/contact';
import Social from '../pages/social';

const Footer = () => {
    return (
        <footer className={styles.footerContainer}>
            <h2>Samband</h2>
            <div className={styles.contactDetails}>
            <Contact />
            <Social />
            </div>
        </footer>
    );
};

export default Footer;
